<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="button clear button--only-icon menu-item"
      :class="{ 'is-active': isActive || isChildMenuActive }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <fluent-icon
        :icon="icon"
        :fill="iconFill"
        :overrideFill="isAttentionNeeded && priorityCount > 0 ? 'red' : null"
        class="icon"
        :class="{
          'glow-red': isAttentionNeeded && priorityCount > 0,
        }"
      />
      <span class="show-for-sr">{{ name }}</span>

      <span
        v-if="isAttentionNeeded && priorityCount > 0"
        class="priority-counter"
        :aria-label="`Priority conversations: ${displayPriorityCount}`"
      >
        {{ displayPriorityCount }}
      </span>

      <span v-if="isBeta" label="Beta" class="beta">Beta</span>
      <span v-if="isNew" class="beta">{{
        $t('INTEGRATION_SETTINGS.OPEN_AI.BETA')
      }}</span>
    </a>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconFill: {
      type: String,
      default: 'currentColor',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
    isBeta: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isAttentionNeeded: {
      type: Boolean,
      default: false,
    },
    priorityCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    displayPriorityCount() {
      return this.priorityCount >= 100 ? '+99' : this.priorityCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  margin: var(--space-small) 0;
}

.menu-item {
  display: inline-flex;
  position: relative;
  border-radius: var(--border-radius-large);
  border: 1px solid transparent;
  color: var(--b-600);
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--w-25);
    color: var(--b-600);
  }

  &:focus {
    border-color: var(--c-500);
  }

  &.is-active {
    background: var(--c-100);
    color: var(--c-500);
  }

  .beta {
    padding: 0 var(--space-smaller);
    margin-left: var(--space-smaller);
    display: inline-block;
    font-size: 8px;
    font-weight: var(--font-weight-medium);
    line-height: 13px;
    border: 1px solid var(--g-700);
    border-radius: 2em;
    background: var(--g-800);
    color: #fff;
    position: absolute;
    left: 12px;
    bottom: 3px;
  }
}

.icon {
  font-size: var(--font-size-default);
}

.priority-counter {
  position: absolute;
  bottom: -1px;
  right: -2px;
  background: #ffc107;
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.glow-red {
  color: red !important;
}
</style>
